import styles from '../../DealerLocator.module.scss';
import cx from 'classnames';

interface DealerLocatorSearchResultAddressProps {
  children: string;
}

export const DealerLocatorSearchResultAddress = ({
  children
}: DealerLocatorSearchResultAddressProps) => (
  <p
    className={cx(
      styles['dealer-locator-text'],
      'cat-u-theme-typography-body my-0'
    )}
  >
    {children}
  </p>
);
